<script setup lang="ts">
import {RouterView} from 'vue-router'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import {onMounted, onUnmounted, provide, ref} from 'vue';
import type {Cate} from './types/types.d.ts'
import getStatus from '@/api/getStatus'
import {userinfo} from '@/stores/counter'
import addViews from './api/addViews';
import {getCates} from "@/api/getCates";
import {getMenuNavs} from "@/api/getMenuNavs";

const {viewing} = addViews()
const userInfoCard = ref();
const user = userinfo()
const {status} = getStatus();
const cates = ref<Cate[]>([])

const menuNavs = ref([])

provide('menuNavs', menuNavs)
provide('cates', cates)

function closeUser(e: any) {
  if (!user.showUser) {
    return;
  }
  if (!userInfoCard.value.contains(e.target)) {
    if (e.target.id == "gosignup" || e.target.id == "gologin") return
    user.showUser = false;
  }
}

onMounted(async () => {
  viewing();
  await status();
  userInfoCard.value = document.getElementById("userInfo")
  document.addEventListener('mousedown', closeUser)

  const {cates: resCates} = await getCates()
  cates.value = resCates

  const {navs} = await getMenuNavs()
  menuNavs.value = navs
})

onUnmounted(() => {
  document.removeEventListener('mousedown', closeUser)
})
</script>

<template>
  <el-container class="all-main" v-if="cates">
    <el-header>
      <Header/>
    </el-header>
    <el-main>
      <RouterView/>
      <Footer/>
    </el-main>
  </el-container>
</template>

<style scoped>
.el-header {
  padding: 0;
  height: fit-content;
}

.el-main {
  padding: 0;
  overflow: revert;
}

.all-main {
  min-width: 1200px;
}

/* 
::v-deep(.el-message) {
  border-color: #fa7c0a !important;
  background-color: #fffcf9 !important;
}

::v-deep .el-message--success .el-message__content {
  color: #fa7c0a !important;
} */
</style>
